document.addEventListener('DOMContentLoaded', () => {
    MicroModal.init();
});
